module.exports = __webpack_public_path__ + "static/media/pie-chart-icon.4190b16e.svg";